export default {
	"models.available": "可用",
	"models.expired": "已失效",
	"models.unavailable": "不可用",
	"models.wrongType": "錯誤的type：",
	"models.error": "出錯了",
	"models.ReceivedSuccessfully": "領取成功",
	"models.loading": "正在加載..."
}